import React from 'react'

export default function Button({ onClick, label, style, disabled, icon, variant, disabledNote }) {

    if (variant === "primary" || !variant)
        return (
            <>
                <button className='button' disabled={disabled} onClick={onClick} style={{ marginBottom: disabledNote ? '5px' : '15px', ...style, justifyContent: icon ? 'space-between' : 'center', paddingRight: '15px', paddingLeft: '15px', flexDirection: 'column', minHeight: 'fit-content', paddingBottom: '5px' }}>
                    <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <p style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>{label}</p>
                        {icon}
                    </div>


                </button>
                {disabled &&
                    <span style={{ fontSize: '10px', width: '100%', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                        {disabledNote}
                    </span>
                }
            </>
        )
    else if (variant === "border") {
        return (
            <>
                <button className='button' disabled={disabled} onClick={onClick} style={{ marginBottom: disabledNote ? '5px' : '15px', ...style, justifyContent: icon ? 'space-between' : 'center', paddingRight: '15px', paddingLeft: '15px', backgroundColor: 'transparent', border: '1px solid #DA3831', minHeight: 'fit-content', paddingBottom: '5px' }}>
                    <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <p style={{ color: '#DA3831' }} >{label}</p>
                        {icon}
                    </div>

                </button>
                {disabled &&
                    <span style={{ fontSize: '10px', width: '100%', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                        {disabledNote}
                    </span>
                }
            </>

        )
    }
}
